<template>
  <div>
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" /> -->
    <span @click="url" class="text-inherit hover:text-primary cursor-pointer">{{ params.value }}</span>
  </div>
</template>

<script>
import personasStore from '@/store/gestion/personas/index.js'

export default {
  name: 'CellRendererLink',
  methods: {
    async url () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      try {
        if (!personasStore.isRegistered) {
          this.$store.registerModule('personasStore', personasStore)
          personasStore.isRegistered = true
        }

        await this.$store.dispatch('personasStore/getPersona', this.params.data.id)
          .then((response) => {
            this.persona = response.data
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          })
          .catch(
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          )
      } catch (error) {
        console.error(error)
      }
      const ruta = `/gestion/clientes/ver/${this.params.data.id}`
      this.$router.push(ruta).catch(() => {})
    }
  }
}
</script>
